/**
 * @param <String> class名
 * @description 设置table表格高度随屏幕高度自适应
 */
import $ from 'jquery'
export const tdWidth = {
  sm: 50,
  middle: 120,
  large: 180
}
export function setTableHeight(elName) {
  let height = $('.' + elName).height()
  return height
}
export function setChartOptions(dataX, dataY, yName) {
  return {
    color: ['#353736'],
    title: {
      text: ''
    },
    legend: {
      data: ['']
    },
    toolbox: {
      feature: {
        saveAsImage: {}
      }
    },
    grid: {
      left: '0%',
      right: '0%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        boundaryGap: true,
        axisTick: {
          show: false
        },
        name: '日期',
        nameTextStyle: {
          padding: [25, 0, 0, -50],
          fontSize: 16
        },
        axisLine: {
          lineStyle: {
            type: 'dotted',
            color: '#636466', // 左边线的颜色
            width: '1' // 坐标线的宽度
          }
        },
        axisLabel: {
          fontSize: 16
        },
        data: dataX
      }
    ],
    yAxis: [
      {
        type: 'value',
        name: yName,
        nameTextStyle: {
          padding: [20, 0, -30, 95],
          fontSize: 16
        },
        axisTick: {
          show: false
        },
        splitLine: {
          show: false
        },
        axisLabel: {
          formatter: function (value, index) {
            var texts = []
            return texts
          }
        },
        axisLine: {
          lineStyle: {
            type: 'dotted',
            color: '#636466', // 左边线的颜色
            width: '1' // 坐标线的宽度
          }
        },
        min: function (value) {
          return value.min - 5
        }
      }
    ],
    series: [
      {
        name: '',
        type: 'line',
        symbol: 'circle',
        symbolSize: 10,
        stack: '',
        label: {
          normal: {
            show: true,
            position: 'top',
            fontSize: 16
          }
        },
        itemStyle: {
          normal: {
            color: '#1aaeb8',
            lineStyle: {
              color: '#1aaeb8'
            }
          }
        },
        data: dataY
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/common/js/dom.js